// extracted by css-extract-rspack-plugin
module.exports =  {"speech":"TextToSpeech-m1j0__speech"};